import { Component, Input } from '@angular/core';

@Component({
  selector: 'tracking-page-stepper-arrow',
  template: `
    <div
      [style.position]="'absolute'"
      [style.left]="'-11px'"
      [style.background]="'#F7F7F7'"
      [style.height]="'24px'"
      [style.width]="'24px'">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [attr.fill]="colorHex">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM7.3415 11.7474C6.92586 12.1111 6.88374 12.7429 7.24742 13.1585C7.6111 13.5741 8.24287 13.6163 8.6585 13.2526L11 11.2038V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V11.2038L15.3415 13.2526C15.7571 13.6163 16.3889 13.5741 16.7526 13.1585C17.1163 12.7429 17.0741 12.1111 16.6585 11.7474L12.6585 8.24742C12.2815 7.91753 11.7185 7.91753 11.3415 8.24742L7.3415 11.7474Z"
          fill="884DFF" />
      </svg>
    </div>
  `,
  standalone: false,
})
export class TrackingPageStepperArrow {
  @Input() colorHex: string;

  constructor() {}
}
